var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckOutlinedColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.666,
    height: 22.367,
    viewBox: "0 0 20.666 22.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18435"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.333 22.367a2.319 2.319 0 0 1-1.621-.656l-4.34-4.2A14.405 14.405 0 0 1 0 7.21V5.017a2.323 2.323 0 0 1 2.114-2.323l.433-.041A12.4 12.4 0 0 0 7.753.94l.689-.414a3.665 3.665 0 0 1 3.782 0l.689.414a12.406 12.406 0 0 0 5.206 1.714l.433.041a2.323 2.323 0 0 1 2.114 2.323V7.21a14.4 14.4 0 0 1-4.37 10.3l-4.34 4.2a2.322 2.322 0 0 1-1.623.657zm0-20.367a1.661 1.661 0 0 0-.859.239l-.689.414a14.424 14.424 0 0 1-6.049 1.991l-.436.041a.333.333 0 0 0-.3.332V7.21a12.4 12.4 0 0 0 3.761 8.867l4.34 4.2a.333.333 0 0 0 .463 0l4.34-4.2a12.4 12.4 0 0 0 3.763-8.867V5.017a.333.333 0 0 0-.3-.332l-.434-.041a14.424 14.424 0 0 1-6.049-1.991l-.688-.414A1.666 1.666 0 0 0 10.333 2z",
    style: {
      fill: "#1bc47d"
    },
    "data-name": "Shield"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.28.22a.75.75 0 0 1 0 1.061l-7 7a.75.75 0 0 1-1.061 0l-4-4A.75.75 0 0 1 1.28 3.22l3.47 3.47L11.22.22a.75.75 0 0 1 1.06 0z",
    transform: "translate(4.083 6.971)",
    style: {
      fill: "#1bc47d"
    },
    "data-name": "Check"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutlinedColored);
export default __webpack_public_path__ + "static/media/check-outlined-colored.31b0962e416567c9e5112a0c2fe1670f.svg";
export { ForwardRef as ReactComponent };